export default __webpack_public_path__ + "assets/images/error.bc384a.png";